import { render, staticRenderFns } from "./sponser-member-add-edit.vue?vue&type=template&id=229efd5b&scoped=true&"
import script from "./sponser-member-add-edit.vue?vue&type=script&lang=js&"
export * from "./sponser-member-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./sponser-member-add-edit.vue?vue&type=style&index=0&id=229efd5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229efd5b",
  null
  
)

component.options.__file = "sponser-member-add-edit.vue"
export default component.exports